import styled, { css } from 'styled-components';
import { colors } from 'globalStyles';
import { NavLink } from 'react-router-dom';
import { media } from 'utils/style-utils';


export const Wrapper = styled.div`
  padding-top: 80px;
  height: 100%;
  background-color: ${colors.WHITE};
  ${ media.mobile_and_tablet`
      padding-top: 0px;
  `}

  ${ media.tablet`
      height: 80px;
  `}

  ${ media.mobile`
      height: 54px;
  `}
`;

export const activeStyles = css`
  background-color: rgba(255,255,255,0.08);
`;

export const NavContainer = styled.div`
  position: fixed;
  background-color: ${colors.MENU};
  color: ${colors.MENU_LINK};
  font-size: 12px;
  height: 100%;
  width: 250px;
  padding: 80px 0;
  top: 0;
  left: 0;

  ${ media.mobile_and_tablet`
    width: 100%;
    position: relative;
    padding: 0 20px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E7EBEC;
  `}
`;

export const Content = styled.div`
  margin-left: 250px;
  background-color: ${colors.WHITE};
  padding-bottom: 350px;
  position: relative;
  min-height: 100%;

  .footer-logo {
    position: absolute;
    bottom: 30px;
    left: 50%;
    margin-left: -65px;
  }

  ${ media.mobile_and_tablet`
    margin-left: 0px;
  `}

  ${ media.tablet`
    padding: 69px;
  `}

  ${ media.mobile`
    padding: 40px 10px;
  `}
`;


const navItemStyles = css`
  color: ${colors.MENU_LINK};
  display: block;
  font-family: poppins, sans-serif;
  width: 100%;
  height: 44px;
  line-height: 44px;
  padding: 0 5em;

  ${ media.mobile_and_tablet`
    padding: 5px;
    width: fit-content;
  `}

`;

export const MenuList = styled.div`
  overflow: auto;
  height: 100%;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background: ${colors.MENU}; 
  }
  &::-webkit-scrollbar-thumb {
    background: #888; 
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }

  ${ media.mobile_and_tablet`
      overflow: visible;
      display: contents;
  `}
`;


export const HomeIcon = styled.div`
  margin-bottom: 2em;

  ${ media.mobile_and_tablet`
      margin: 24px 0 24px 30px;
  `}
`;

export const SignOutButton = styled.button`
  bottom: 20px;
  position: absolute;
  width: 100%;

  ${navItemStyles}

  &:hover {
    ${activeStyles}
  }

  ${ media.mobile_and_tablet`
    display: contents;
  `}
`;

const linkStyles = css`
  ${navItemStyles}
  align-items: center;
  display: flex;

  &:hover {
    ${activeStyles}
    ${ media.mobile`
      span{
        visibility: visible;
      }
    `}
  }

  & span {
    margin: 0 0 0 1em;
    
    ${ media.mobile`
      visibility: hidden;
      width: 80px;
      text-align: center;
      position: absolute;
      z-index: 1;
      margin: 15px 2px;
  `}
  }
`;

export const A = styled.a`
  ${linkStyles}
`;

export const StyledLink = styled(NavLink)`
  ${linkStyles}

  &.${({ activeClassName }) => activeClassName} {
    color: ${colors.ACTIVE_COLOR};
    font-weight: bold;

    & svg g {
      fill: ${colors.ACTIVE_COLOR};
    }
  }
`;

export const Img = styled.img`
  width: 30px;
  border-radius: 50%;
`;



// WEBPACK FOOTER //
// ./src/components/LeftMenu/styledComponents.js